import React from 'react';

import {
  SELLER_ASSISTANCE_TYPE,
  sellerAssistanceTypes,
} from '../../config/constants';
import { DangerText } from './Components/ContractText';
import EqualSellerandBuyerFee from './Components/UnbeatableClause/EqualSellerandBuyerFee';
import NoSellerAssistance from './Components/UnbeatableClause/NoSellerAssistance';
import PayUnbeatableFee from './Components/UnbeatableClause/PayUnbeatableFee';
import SerllerPayBuyerAgentFee from './Components/UnbeatableClause/SerllerPayBuyerAgentFee';

interface UnbeatableClauseProps {
  buyerAgentCompensation?: number;
  offerPrice?: number;
  sellerAssistanceTypes?: string;
  sellerAssistanceClosingCosts?: number;
}

const UnbeatableClause = ({
  buyerAgentCompensation,
  offerPrice,
  sellerAssistanceTypes,
  sellerAssistanceClosingCosts,
}: UnbeatableClauseProps) => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Unbeatable Clause
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          Unbeatable Loans LLC's platform provides a secure environment for both
          parties to amend and finalize the terms of this agreement.
        </li>
        <li>
          Both parties agree $1,000 contract negotiation fee is payable to
          Unbeatable Loans LLC as part of the Buyer's closing costs. This fee is
          due at the time of closing or via deposit. This agreement constitutes
          acknowledgment of the invoice.
        </li>
        <li>
          Wiring Instructions are provided by Unbeatable Loans LLC. Please
          verify the instructions with your transaction manager before sending
          any funds.
        </li>
        <li>
          This transaction will have a transaction manager assigned by
          Unbeatable Loans LLC to represent the interests of the Buyer. The
          transaction manager will be responsible for facilitating the
          negotiation process, ensuring compliance, and providing support
          throughout the transaction typically handled by a buyers agent.
        </li>
        <li>
          The transaction manager will be available to answer any questions and
          provide assistance during the negotiation process. Please contact your
          transaction manager for any inquiries or concerns.
        </li>
        <li>
          Both parties agree to the use of electronic signatures for the
          execution of this contract. Electronic signatures are legally binding
          and have the same force as handwritten signatures. By signing this
          agreement electronically, both parties acknowledge that they have
          read, understood, and agreed to the terms and conditions.
        </li>
        <li>
          {sellerAssistanceTypes ===
          SELLER_ASSISTANCE_TYPE.SELLER_TO_PAY_BUYER_AGENT_FEE_ADDITIONAL_SELLER_CREDIT ? (
            <SerllerPayBuyerAgentFee
              buyerAgentCompensation={buyerAgentCompensation}
              offerPrice={offerPrice}
              sellerAssistanceClosingCosts={sellerAssistanceClosingCosts}
            />
          ) : sellerAssistanceTypes ===
            SELLER_ASSISTANCE_TYPE.SELLER_CREDIT_EQUALS_BUYER_AGENT_FEE ? (
            <EqualSellerandBuyerFee
              buyerAgentCompensation={buyerAgentCompensation}
              offerPrice={offerPrice}
            />
          ) : sellerAssistanceTypes ===
            SELLER_ASSISTANCE_TYPE.SELLER_TO_PAY_UNBEATABLE_FEE ? (
            <PayUnbeatableFee />
          ) : (
            <NoSellerAssistance />
          )}
        </li>
      </ol>
    </div>
  );
};

export default UnbeatableClause;
